import React, { useState } from 'react';
import PurchaseUpload from './BulkUpload';
import SalesUpload from './SalesUpload';
import CreditUpload from './CreditUpload';
import PaymentUpload from './PaymentUpload';


export default function UploadsTabs() {
  const [activeTab, setActiveTab] = useState("purchase");

  const tabs = [
    { key: "purchase", label: "Purchase Upload" },
    { key: "sales", label: "Sales Invoice Upload" },
    { key: "credit", label: "Credit Note Upload" },
    { key: "payment", label: "Payment Upload" },
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex space-x-4 border-b mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 font-medium ${
              activeTab === tab.key
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-600"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "purchase" && <PurchaseUpload />}
      {activeTab === "sales" && <SalesUpload />}
      {activeTab === "credit" && <CreditUpload />}
      {activeTab === "payment" && <PaymentUpload />}
    </div>
  );
}
